import { render, staticRenderFns } from "./RelationsECharts.vue?vue&type=template&id=5642995c"
import script from "./RelationsECharts.vue?vue&type=script&lang=js"
export * from "./RelationsECharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports